(function () {
  if (window.__roveLocationCardsJs) {
    return;
  }

  window.__roveLocationCardsJs = true;

  const SELECTORS = {
    section: '.rove-location-cards',
    filters: '.rove-location-cards__filters',
    grid: '.rove-location-cards__grid',
    card: '.rove-location-card',
    filterInput: '.rove-location-cards__filter-input',
    badge: '.rove-location-card__badge',
    badgePopup: '.rove-location-card__badge-popup',
    badgeClose: '.rove-location-card__badge-close',
    badgePanel: '.rove-location-card__badge-popup-panel',
  };

  const FILTER_CLASSES = 'rove-location-cards__filter button outline small';

  function getCardGroup(card) {
    return (card.dataset.locationGroup || '').trim();
  }

  function getSectionId(section) {
    const shopifySection = section.closest('.shopify-section');

    if (shopifySection?.id) {
      return shopifySection.id.replace('shopify-section-', '');
    }

    return section.dataset.sectionId || Math.random().toString(36).slice(2);
  }

  class LocationCardsFilters {
    constructor(section) {
      this.section = section;
      this.filtersEl = section.querySelector(SELECTORS.filters);
      this.gridEl = section.querySelector(SELECTORS.grid);

      if (!this.filtersEl || !this.gridEl) {
        return;
      }

      this.cards = [...this.gridEl.querySelectorAll(SELECTORS.card)];
      this.sectionId = getSectionId(section);
      this.render();
    }

    getUniqueGroups() {
      const groups = new Set();

      for (const card of this.cards) {
        const group = getCardGroup(card);

        if (group) {
          groups.add(group);
        }
      }

      return [...groups].sort((a, b) =>
        a.localeCompare(b, undefined, { sensitivity: 'base' })
      );
    }

    getSelectedGroups() {
      return [...this.filtersEl.querySelectorAll(SELECTORS.filterInput)]
        .filter((input) => input.checked)
        .map((input) => input.value);
    }

    updateVisibility() {
      const selected = new Set(this.getSelectedGroups());
      const showAll = selected.size === 0;

      for (const card of this.cards) {
        const group = getCardGroup(card);
        card.hidden = !showAll && (!group || !selected.has(group));
      }
    }

    createFilterChip(group, index) {
      const inputId = `rove-location-filter-${this.sectionId}-${index}`;
      const label = document.createElement('label');
      const input = document.createElement('input');
      const text = document.createElement('span');

      label.className = FILTER_CLASSES;

      input.type = 'checkbox';
      input.className = 'rove-location-cards__filter-input';
      input.id = inputId;
      input.value = group;
      input.name = `rove-location-filter-${this.sectionId}`;

      text.textContent = group;

      label.append(input, text);

      return label;
    }

    render() {
      const groups = this.getUniqueGroups();
      const fragment = document.createDocumentFragment();

      for (const [index, group] of groups.entries()) {
        fragment.append(this.createFilterChip(group, index));
      }

      this.filtersEl.replaceChildren(fragment);
      this.filtersEl.hidden = groups.length === 0;
      this.filtersEl.onchange = () => this.updateVisibility();

      if (groups.length === 0) {
        this.updateVisibility();
      }
    }
  }

  function eventElement(event) {
    const target = event.target;

    if (target instanceof Element) {
      return target;
    }

    return target?.parentElement || null;
  }

  function closestFromEvent(event, selector) {
    return eventElement(event)?.closest(selector) || null;
  }

  function findFromPoint(event, selector) {
    const match = closestFromEvent(event, selector);

    if (match) {
      return match;
    }

    if (typeof event.clientX !== 'number' || typeof document.elementsFromPoint !== 'function') {
      return null;
    }

    return (
      document
        .elementsFromPoint(event.clientX, event.clientY)
        .find((node) => node instanceof Element && node.closest(selector))
        ?.closest(selector) || null
    );
  }

  function isPopupOpen(popup) {
    return Boolean(popup && !popup.hidden && popup.classList.contains('is-open'));
  }

  function closeBadgePopup(popup, badge, options) {
    if (!popup || (!isPopupOpen(popup) && popup.hidden)) {
      return;
    }

    popup.hidden = true;
    popup.classList.remove('is-open');

    if (badge) {
      badge.setAttribute('aria-expanded', 'false');

      if (!options?.silent) {
        badge.focus();
      }
    }
  }

  function openBadgePopup(popup, badge) {
    if (!popup) {
      return;
    }

    document.querySelectorAll(SELECTORS.badgePopup).forEach((openPopup) => {
      if (openPopup !== popup) {
        const otherBadge = openPopup
          .closest(SELECTORS.card)
          ?.querySelector(SELECTORS.badge);

        closeBadgePopup(openPopup, otherBadge, { silent: true });
      }
    });

    popup.hidden = false;
    popup.classList.add('is-open');
    badge?.setAttribute('aria-expanded', 'true');
    popup.querySelector(SELECTORS.badgeClose)?.focus();
  }

  function toggleBadgePopup(badge) {
    const popup = badge
      .closest(SELECTORS.card)
      ?.querySelector(SELECTORS.badgePopup);

    if (!popup) {
      return;
    }

    if (isPopupOpen(popup)) {
      closeBadgePopup(popup, badge);
      return;
    }

    openBadgePopup(popup, badge);
  }

  function initBadgeEvents() {
    if (initBadgeEvents.bound) {
      return;
    }

    initBadgeEvents.bound = true;

    document.addEventListener(
      'click',
      (event) => {
        const closeBtn = findFromPoint(event, SELECTORS.badgeClose);
        const badge = findFromPoint(event, SELECTORS.badge);
        const popup = findFromPoint(event, SELECTORS.badgePopup);
        const panel = findFromPoint(event, SELECTORS.badgePanel);

        if (closeBtn) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const card = closeBtn.closest(SELECTORS.card);
          closeBadgePopup(
            card?.querySelector(SELECTORS.badgePopup),
            card?.querySelector(SELECTORS.badge)
          );
          return;
        }

        if (badge) {
          event.preventDefault();
          event.stopImmediatePropagation();
          toggleBadgePopup(badge);
          return;
        }

        if (popup && !panel) {
          event.preventDefault();
          event.stopImmediatePropagation();
          closeBadgePopup(
            popup,
            popup.closest(SELECTORS.card)?.querySelector(SELECTORS.badge)
          );
        }
      },
      true
    );

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') {
        return;
      }

      const openPopup = [...document.querySelectorAll(SELECTORS.badgePopup)].find(
        isPopupOpen
      );

      if (!openPopup) {
        return;
      }

      closeBadgePopup(
        openPopup,
        openPopup.closest(SELECTORS.card)?.querySelector(SELECTORS.badge)
      );
    });
  }

  function initSection(section) {
    return new LocationCardsFilters(section);
  }

  function initAll() {
    document.querySelectorAll(SELECTORS.section).forEach(initSection);
  }

  initBadgeEvents();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector(SELECTORS.section);

    if (section) {
      initSection(section);
    }
  });
})();
